/** @format */

import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

// 用户管理-右边列表
export function getOrgList(data: API.SystemParam) {
	return request<BaseResponse<API.BaseConfigResult>>({
		url: '/base/rbac/employee/page',
		method: 'post',
		data,
	});
}
